import { render, staticRenderFns } from "./EditDefinition.vue?vue&type=template&id=0122326f&"
import script from "./EditDefinition.vue?vue&type=script&lang=ts&"
export * from "./EditDefinition.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports